import orderedRecords from "./orderedRecords";
import orderedRecordsItem from "./orderedRecordsItem";

export default `
${orderedRecords}
${orderedRecordsItem}
`;
